export enum MediaType {
    Blog = 'social_blogs',
    Comments = 'social_comments',
    EditorialBlog = 'editorial_blogs',
    Facebook = 'facebook',
    Forums = 'social_message_boards',
    Instagram = 'instagram',
    News = 'news',
    ProductReview = 'social_reviews',
    Radio = 'tveyes_radio',
    Television = 'tveyes_television',
    Twitter = 'twitter',
    Youtube = 'youtube'
}

export interface IPotentialReach {
    mobile: number,
    desktop: number
} 

export interface ISocialScores {
    tw_followers?: number
    tw_likes?: number
    tw_replies?: number
    tw_retweets?: number
    fb_likes?: number
    yt_views?: number
    tw_shares ?: number
    fb_shares ?: number
    rd_shares ?: number
}

export class MediaDocument {
    __originalDocument__: any;
    authors: Array<Author>;
    body: string;
    date: number | Date;
    documentId: string;
    dupDocs: Array<MediaDocument>;
    dupDocsCount: number;
    dupDocsVisibleCount: number = 0;
    dupDocsLoading: boolean = false;
    dupDocsIdsRemaining: Array<string>;
    ingress: string;
    isFixedMediaAspectRatio: boolean = true;
    isHosted: boolean = false;
    isDuplicate: boolean = false;
    keywords: Array<string>;
    language: string;
    matchSentences: Array<string>;
    mediaImageUrl: string;
    mediaType: MediaType;
    mediaTypeIcon: string;
    provider: string;
    sourceAvatarImgUrl: string;
    sourceAvatarRounded: boolean = false;
    sourceAvatarLinkUrl: string;
    sourceCountryCode: string;
    sourceId: string;
    sourceName: string;
    sourceNameUrl: string;
    reachCount: number;
    potentialReach: IPotentialReach | null;
    reachUrl: string;
    tags: Array<string>;
    bodyTruncationLength: number;
    selected: boolean = false;
    sentiment: string;
    sentimentOverride: string;
    socialEchoDocumentUrl: string;
    title: string;
    titleUrl: string;
    unread: boolean = false;
    url: string;
    videoUrl: string;
    engagement: number | null
    engagementLastUpdateDate: number | null
    socialScores: ISocialScores | null

    constructor(originalDoc?: any) {
        this.__originalDocument__ = originalDoc;
    }
}

export interface Author {
    name?: string,
    url?: string,
    handle?: string,
    authorInfo?: {
        externalId: string
        id: string
    },
    avatarUrl?: string
    icmUrl?: string
}